import { useContext } from 'react'
import { CandidateSearchContext } from 'recruiter/contexts'

/**
 * Provides access to values in the candidate search context.
 */
export const useCandidateSearch = () => {
    const candidateSearchContext = useContext(CandidateSearchContext)

    if (!candidateSearchContext) {
        throw new Error(
            'useCandidateSearch must be used within <CandidateSearchProvider>'
        )
    }

    return candidateSearchContext
}
